import { render, staticRenderFns } from "./ArrowForwardIcon.vue?vue&type=template&id=05950b34&scoped=true&"
import script from "./ArrowForwardIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ArrowForwardIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05950b34",
  null
  
)

export default component.exports